module.exports = " <h6>Votre navigateur est obsolète!</h6> <p>Mettez à jour votre navigateur pour afficher correctement ce site Web. <a id=btnUpdateBrowser href=http://outdatedbrowser.com/fr>Mettre à jour maintenant </a></p> <p class=last><a href=# id=btnCloseUpdateBrowser title=Fermer>&times;</a></p> ";


//////////////////
// WEBPACK FOOTER
// ./outdated-browser/lang/fr.html
// module id = 820
// module chunks = 2